import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getAllServiceList } from "../../../config/allServiceJSON";
import OAuth2Authenticator from "./Auth2Authenticator/OAuth2Authenticator";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

function Authentication(props) {
  const {
    children,
    tabIndex,
    index,
    orgId,
    apiKey,
    dataCenterUrl,
    dataCenter,
    zApiKey,
    auth,
    setAuth,
    serviceApiKey,
    setServiceApiKey,
    setTabIndex,
    allUsers,
    currentUser,
    setSnack,
    ...other
  } = props;

  const [authServices, setAuthServices] = useState([]);

  useEffect(() => {
    if (orgId && apiKey && zApiKey && dataCenterUrl && dataCenter) {
      if (
        authServices.includes("Zoho") &&
        (authServices.includes("Workdrive") ||
          authServices.includes("Sharepoint"))
      ) {
        setAuth(true);
      } else {
        setAuth(false);
      }
    }
  }, [authServices]);

  const handlefetchConnections = async () => {
    try {
    } catch (error) {}
  };

  if (tabIndex !== index) {
    return <></>;
  }

  const allServices = getAllServiceList(dataCenter) || [];
  const nonZohoServices = allServices.filter((s) => s?.name !== "Zoho");
  const zohoService = allServices.find((s) => s?.name === "Zoho");

  return (
    <div
      role="tabpanel"
      hidden={tabIndex !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {/* Render Zoho Authenticator Alone */}
      {zohoService && (
        <Box
          sx={{
            py: 1,
            width: "100%",
            // maxWidth: "1148px"
          }}
        >
          <OAuth2Authenticator
            setAuthServices={setAuthServices}
            orgId={orgId}
            apiKey={apiKey}
            dataCenter={dataCenter}
            zApiKey={zApiKey}
            setSnack={setSnack}
            service={zohoService}
            allUsers={allUsers}
            currentUser={currentUser}
            dataCenterUrl={dataCenterUrl}
            handlefetchConnections={handlefetchConnections}
          />
        </Box>
      )}

      {/* Render Backup Section with Non-Zoho Services */}
      {nonZohoServices.length > 0 && (
        <Box
          sx={{
            border: "1px solid #D7E2ED",
            borderRadius: 2,
            py: 2,
            // mx: "auto",
            width: "100%",
            // maxWidth: "1148px",
            mt: 2,
            backgroundColor: "#F5F7F9",
          }}
        >
          <Box sx={{ px: 2 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              Select Backup Destination
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Please connect at least one backup service — WorkDrive or
              SharePoint — before continuing to Backup Settings.
            </Typography>
          </Box>

          <Grid container>
            {nonZohoServices.map((service, index) => (
              <Grid item size={{ md: 6 }} key={index} sx={{ mb: 2 }}>
                <OAuth2Authenticator
                  setAuthServices={setAuthServices}
                  orgId={orgId}
                  apiKey={apiKey}
                  dataCenter={dataCenter}
                  zApiKey={zApiKey}
                  setSnack={setSnack}
                  service={service}
                  allUsers={allUsers}
                  currentUser={currentUser}
                  dataCenterUrl={dataCenterUrl}
                  handlefetchConnections={handlefetchConnections}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          // mx: "auto",
          // py: 1,
          width: "100%",
        }}
      >
        <Button
          sx={{
            textTransform: "none",
            mt: 1,
          }}
          variant="contained"
          disabled={
            !(
              authServices.includes("Zoho") &&
              (authServices.includes("Workdrive") ||
                authServices.includes("Sharepoint"))
            )
          }
          endIcon={<ArrowForwardIcon />}
          onClick={() => {
            setTabIndex((prev) => 1);
          }}
        >
          Continue to Backup Settings
        </Button>
      </Box>
    </div>
  );
}

export default Authentication;
